import I18n from 'I18n';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import partial from 'transmute/partial';
import FormattedMessage from 'I18n/components/FormattedMessage';
import http from 'hub-http/clients/apiClient';
import { Button } from 'foundations-components/transitional/components/Button';
import { TextInput } from 'foundations-components/transitional/components/TextInput';

// @ts-expect-error No types
import UIValidatedEmailFormControl from 'ui-addon-form-validation/Email/UIValidatedEmailFormControl';
import RequireEmailAddress from './shareOptions/RequireEmailAddress';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import DocumentBrandProperty from 'documents-ui/components/brand/DocumentBrandProperty';
import { isMultiBrandEnabled } from 'documents-lib/js/utils/isMultiBrandEnabled';
import { makeGetDocumentMetadata } from '../../selectors/DocumentSummarySelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreateLinkSetup = ({
  deckId,
  email,
  isValidated,
  requireEmail,
  onEmailChange,
  onEmailValidation,
  onRequireEmailChange,
  onCreateLink,
  legalConsentEnabled
}) => {
  const getDocumentMetadata = useMemo(() => makeGetDocumentMetadata(), []);
  const documentMetadata = useSelector(state => getDocumentMetadata(state, deckId));
  const brandId = documentMetadata.get('brandId');
  const showShareOptions = !legalConsentEnabled;
  const shareOptions = /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "800",
    marginInlineStart: "-50",
    children: /*#__PURE__*/_jsx(AccordionItem, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createLink.shareOptions.title"
      }),
      defaultOpen: true,
      children: /*#__PURE__*/_jsx(RequireEmailAddress, {
        requireEmail: requireEmail,
        onChange: e => onRequireEmailChange(e.target.checked)
      })
    })
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Text, {
      marginBlockEnd: "100",
      as: "p",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createLink.shareCTA"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(UIValidatedEmailFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "createLink.emailInput.title"
        }),
        required: true,
        httpClient: http,
        type: "apiFast",
        onSuccess: partial(onEmailValidation, true),
        onError: partial(onEmailValidation, false),
        children: /*#__PURE__*/_jsx(TextInput, {
          "data-selenium-test": "share-document-email-address-input",
          value: email,
          placeholder: I18n.text('createLink.emailInput.placeholder'),
          onChange: e => onEmailChange(e.target.value),
          onKeyUp: e => e.key === 'Enter' && isValidated && onCreateLink()
        })
      })
    }), isMultiBrandEnabled() && /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(DocumentBrandProperty, {
        brandId: brandId
      })
    }), showShareOptions ? shareOptions : null, /*#__PURE__*/_jsx(Button, {
      "data-selenium-test": "share-document-get-link",
      "data-test-id": "share-document-get-link",
      disabled: !isValidated,
      use: "primary",
      onClick: onCreateLink,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createLink.getLink"
      })
    })]
  });
};
export default CreateLinkSetup;